/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WhatsappInputs */

const en_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const es_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const fr_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const de_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const ja_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const zh_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const ar_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واتساب`)
};

const id_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const it_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const ru_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const pt_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const ko_whatsapp = /** @type {(inputs: WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

/**
* | output |
* | --- |
* | "WhatsApp" |
*
* @param {WhatsappInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const whatsapp = /** @type {((inputs?: WhatsappInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WhatsappInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_whatsapp(inputs)
	if (locale === "es") return es_whatsapp(inputs)
	if (locale === "fr") return fr_whatsapp(inputs)
	if (locale === "de") return de_whatsapp(inputs)
	if (locale === "ja") return ja_whatsapp(inputs)
	if (locale === "zh") return zh_whatsapp(inputs)
	if (locale === "ar") return ar_whatsapp(inputs)
	if (locale === "id") return id_whatsapp(inputs)
	if (locale === "it") return it_whatsapp(inputs)
	if (locale === "ru") return ru_whatsapp(inputs)
	if (locale === "pt") return pt_whatsapp(inputs)
	return ko_whatsapp(inputs)
});